var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmoldubay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 30,
    fill: "#F94171"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20_177)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.8334 50H43.6237C43.2555 50 42.957 49.7015 42.957 49.3333C42.957 48.9651 43.2555 48.6666 43.6237 48.6666H43.8334C44.2015 48.6666 44.5 48.9651 44.5 49.3333C44.5 49.7015 44.2015 50 43.8334 50Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3333 50H16.1667C15.7985 50 15.5 49.7015 15.5 49.3333C15.5 48.9651 15.7985 48.6666 16.1667 48.6666H40.3333C40.7015 48.6666 41 48.9651 41 49.3333C41 49.7015 40.7015 50 40.3333 50Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8502 47.3333H36.41C35.9724 47.3333 35.6561 46.9196 35.7658 46.4959C36.1164 45.1416 36.3529 43.8092 36.3598 43.7208C36.7614 41.3622 36.8065 39.7443 36.8065 37.8333C36.8065 37.8067 36.8048 37.78 36.8015 37.7533C36.7523 35.7325 36.4513 33.7695 36.0265 31.875C35.6706 30.2875 34.8536 28.0713 33.6148 25.8492C33.2442 25.1843 32.5678 24.1632 31.8507 23.2692C29.9898 20.9457 27.6715 19.0933 24.9598 17.7633C24.5139 17.5457 23.9998 17.8716 23.9998 18.3617V46.6667C23.9998 47.0348 23.7013 47.3333 23.3332 47.3333H20.9165C20.5483 47.3333 20.2498 47.0348 20.2498 46.6667V23.25H19.1058C18.7507 23.25 18.4407 22.9818 18.4179 22.6274C18.393 22.2391 18.7003 21.9167 19.0832 21.9167H20.2498V10.6893C20.2498 10.3342 20.518 10.0242 20.8724 10.0014C21.2608 9.9765 21.5833 10.2837 21.5833 10.6667V12.6967C37.6879 15.8912 43.7384 31.5848 39.4936 46.8418C39.413 47.1315 39.1509 47.3333 38.8502 47.3333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5497 25.5H25.9999C25.6318 25.5 25.3333 25.2015 25.3333 24.8334V20.6459C25.3333 20.1185 25.9178 19.7982 26.3606 20.0845C28.1945 21.2697 29.7718 22.7345 31.0754 24.423C31.4148 24.8625 31.105 25.5 30.5497 25.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6368 31.3334H25.9999C25.6318 31.3334 25.3333 31.0349 25.3333 30.6667V27.5C25.3333 27.1319 25.6318 26.8334 25.9999 26.8334H32.2724C32.5195 26.8334 32.7454 26.9704 32.8621 27.1882C33.4162 28.2224 33.8863 29.3145 34.2696 30.455C34.4147 30.8865 34.0921 31.3334 33.6368 31.3334Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.786 37.1666H25.9999C25.6318 37.1666 25.3333 36.8681 25.3333 36.5V33.3333C25.3333 32.9651 25.6318 32.6666 25.9999 32.6666H34.3534C34.6701 32.6666 34.9436 32.8891 35.0073 33.1993C35.2239 34.2554 35.3726 35.3428 35.4516 36.4559C35.4789 36.8405 35.1714 37.1666 34.786 37.1666Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5092 39.1821C35.4794 40.2472 35.3885 41.3298 35.2356 42.4254C35.1896 42.7548 34.9073 43 34.5747 43H25.9999C25.6318 43 25.3333 42.7015 25.3333 42.3333V39.1667C25.3333 38.7985 25.6318 38.5 25.9999 38.5H34.8424C35.2167 38.5 35.5197 38.808 35.5092 39.1821Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7325 45.1457C34.6028 45.7107 34.4567 46.2779 34.2939 46.8469C34.2118 47.1341 33.9505 47.3334 33.6518 47.3334H25.9999C25.6318 47.3334 25.3333 47.0349 25.3333 46.6667V45C25.3333 44.6319 25.6318 44.3334 25.9999 44.3334H34.0817C34.5087 44.3334 34.8281 44.7296 34.7325 45.1457Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20_177"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmoldubay);
export default __webpack_public_path__ + "static/media/smoldubay.5b677752d5dd11e0e0e37f8db123e3f8.svg";
export { ForwardRef as ReactComponent };